import React from 'react';
import { Button, ButtonProps } from 'antd';
import useGoogleAuthUrl from 'hooks/useGoogleAuthUrl';
import { setAutoGoogleCalendarCallbackPath } from 'utils/localstore';

type Props = ButtonProps & {
    successCallbackPath?: string,
    callback?: () => void,
    text?: string,
};

const AuthButton = (props: Props) => {
    const { successCallbackPath, callback, text } = props;
    const [authUrl, authUrlLoading] = useGoogleAuthUrl();

    return (
        <Button
            onClick={() => {
                if (successCallbackPath) {
                    setAutoGoogleCalendarCallbackPath(successCallbackPath);
                }
                if (callback) {
                    callback();
                }
                window.open(authUrl, '_self');
            }}
            disabled={!authUrl}
            type="primary"
            {...props}
        >{text || 'Connect'}
        </Button>
    );
};

export default AuthButton;
